import { ProductType } from '@/lib/types';

import { Role } from './types';

const TRANSITION_360_ROLES: Role[] = [
    Role.transition360Admin,
    Role.transition360Reviewer,
];

export function hasOnlyTransition360Roles(roles: Role[]): boolean {
    return (
        roles.length > 0 &&
        roles.every((role) => TRANSITION_360_ROLES.includes(role))
    );
}

export function getAssignableProducts(
    products: string[],
    { isTransition360FlagOn }: { isTransition360FlagOn: boolean },
): string[] {
    if (isTransition360FlagOn) {
        return products;
    }
    return products.filter((product) => product !== ProductType.transition360);
}
